import {useSearchParams} from "react-router-dom";
import RefData from "../pages/Ref_code";
import Agents from "../pages/Agents";
import { useEffect } from "react";


export function UseClearAgent() {
  const [SearchParams, setSearchParams] = useSearchParams();
  const ClearAgent = () =>{
    const params = new URLSearchParams(SearchParams);
    const getAgentid = localStorage.getItem("agentid");
    if(getAgentid) {
      localStorage.removeItem("agentid");
    }
    params.delete("agent");
    setSearchParams(params);
  }
return ClearAgent;
}

function SearchParam() {
  const [SearchParams] = useSearchParams();
  useEffect(()=>{
    const ref = SearchParams.get("ref");
    if(ref) {
      const Check = RefData.find(item=>item.code.toLowerCase()===ref?.toLowerCase());
      if(Check) {
        localStorage.setItem("refid", Check.code);
      }
    }

    const agentRef = SearchParams.get("agent");
    if(agentRef) {
      const Check = Agents.find(agent=>agent.id.toLowerCase() === agentRef.toLowerCase());
      if(Check) {
        localStorage.setItem("agentid", Check.id);
      }
    }
  }, [SearchParams]);
}
export default SearchParam;